import { render, staticRenderFns } from "./DefectJudgmentModal2.vue?vue&type=template&id=b608adfa"
import script from "./DefectJudgmentModal2.vue?vue&type=script&lang=js"
export * from "./DefectJudgmentModal2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports